import { Controller } from "stimulus"

// Barre latérale fixe de l'éditeur d'articles du blog (besoin 5).
// Un éditeur Trix ne peut être relié qu'à une seule toolbar : la barre
// latérale relaie donc chaque clic vers le bouton correspondant de la vraie
// toolbar (id passé via data-toolbar-id) et reflète en retour l'état
// actif/désactivé des boutons. Les flèches ↑/↓ font défiler la page.
export default class extends Controller {
  connect() {
    this.toolbar = document.getElementById(this.element.dataset.toolbarId)
    if (!this.toolbar) return
    this.syncState = this.syncState.bind(this)
    this.observer = new MutationObserver(this.syncState)
    this.observer.observe(this.toolbar, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class", "disabled", "data-trix-active"]
    })
    this.syncState()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  // évite que le mousedown sur la barre fasse perdre la sélection de l'éditeur
  keepSelection(event) {
    event.preventDefault()
  }

  relay(event) {
    if (!this.toolbar) return
    const realButton = this.toolbar.querySelector(event.currentTarget.dataset.proxySelector)
    if (!realButton || realButton.disabled) return
    ;["mousedown", "click"].forEach((type) => {
      realButton.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }))
    })
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  scrollBottom() {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" })
  }

  syncState() {
    if (!this.toolbar) return
    this.element.querySelectorAll("[data-proxy-selector]").forEach((button) => {
      const real = this.toolbar.querySelector(button.dataset.proxySelector)
      if (!real) return
      button.classList.toggle("trix-active", real.classList.contains("trix-active"))
      button.disabled = real.disabled
    })
  }
}
